import * as React from "react"
import { CardContent } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import NameAndAvatarBadge from "@/app/components/NameAndAvatarBadge"
import { PostCardSize } from "./types"
import { cn } from "@/lib/utils"
import TruncatedTextWithFade from "../TruncatedTextWithFade"

export function PostCardContent({
  blogName,
  blogIcon,
  publishedAt,
  description,
  size,
  hasCoverImg,
}: {
  blogName: string
  blogIcon?: string
  publishedAt: number
  description: string
  size: PostCardSize
  hasCoverImg?: boolean
}) {
  return (
    <CardContent className="px-4 pt-1">
      <div className="flex justify-between items-center mb-3 space-x-1">
        <NameAndAvatarBadge
          imgClassName="rounded-md"
          name={blogName}
          imgSrc={blogIcon}
        />
        <Badge
          variant="muted"
          className="font-sans h-6 text-sm px-2 hidden 4xs:flex font-normal text-nowrap"
        >
          {new Date(publishedAt).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          })}
        </Badge>
      </div>
      <div
        className={cn(
          size === "SMALL" && "line-clamp-3",
          size === "MEDIUM" && "line-clamp-4",
          size === "LARGE" && "line-clamp-4 sm:line-clamp-3"
        )}
      >
        <TruncatedTextWithFade
          className={cn(
            size === "SMALL" && "h-12 bottom-0",
            size === "MEDIUM" && "h-16 -bottom-2",
            size === "LARGE" && "h-16 bottom-0"
          )}
          wrapperClassName={cn(
            size === "LARGE" ? "sm:h-18" : "h-16 ",

            !hasCoverImg && "sm:h-24"
          )}
          cardDescriptionClassName={cn(
            size === "SMALL" ? "line-clamp-3 text-sm" : "h-18",
            "font-body text-muted-foreground"
          )}
        >
          {description}
        </TruncatedTextWithFade>
      </div>
    </CardContent>
  )
}
